import React from "react";

import About from "./About";
import Pricing from "./Pricing";
import FormContact from "./FormContact";
import HeaderSlider from "./HeaderSlider";
import DiaporamaTournoi from "./DiaporamaTournoi";

import AuthIcons from "../../hooks/AuthIcons";
import ScrollIndicator from "../../hooks/ScrollIndicator";
import useScrollToTop from "../../hooks/useScrollToTop";

import { useUser } from "../../contexts/UserContext";

import PublicSection from "../../components/ui/PublicSection";

import { useHomeSettings } from "./hooks/useHomeSettings";
import { useVisitTracker } from "./hooks/useVisitTracker";

import InSituClubsSlider from "./InSituClubsSlider";

function HomePageVitrine() {
  useScrollToTop();
  useVisitTracker();

  const { user } = useUser();
  const { settings, loading: settingsLoading } = useHomeSettings();

  return (
    <main className="min-h-screen w-full max-w-full overflow-x-clip bg-slate-50 text-slate-950 transition-colors duration-300 dark:bg-slate-950 dark:text-white">
      {!user && <AuthIcons />}

      <ScrollIndicator />

      <section
        id="accueil"
        className="relative w-full max-w-full overflow-x-clip"
      >
        <HeaderSlider settings={settings} loading={settingsLoading} />
      </section>

      <PublicSection
        id="description"
        eyebrow="Présentation"
        title="Une application pensée pour organiser vos tournois simplement"
        subtitle="MonAppliTournoi centralise les compétitions, les tableaux, les poules, les résultats, les scoreboards et les outils d’arbitrage dans une interface moderne."
      >
        <About />
      </PublicSection>

      <PublicSection
        id="diaporama"
        eyebrow="En images"
        title="Visualisez l’ambiance de vos compétitions"
        subtitle="Affichez vos tournois, vos podiums, vos espaces d’arbitrage et vos moments forts."
        variant="soft"
      >
        <DiaporamaTournoi />
      </PublicSection>

      <PublicSection
        id="mise-en-situation"
        eyebrow="Clubs utilisateurs"
        title="Mise en situation lors des tournois dans les clubs"
        subtitle="Quelques exemples d’utilisation de MonAppliTournoi sur le terrain, pendant des tournois interclubs ou compétitions officielles"
        variant="default"
      >
        <InSituClubsSlider />
      </PublicSection>

      <PublicSection
        id="tarifs"
        eyebrow="Tarifs"
        title="Une solution accessible pour les clubs, comités et organisateurs"
        subtitle="Des outils complets pour préparer, gérer et valoriser vos compétitions sportives."
      >
        <Pricing />
      </PublicSection>

      <PublicSection
        id="contact"
        eyebrow="Contact"
        title="Vous souhaitez organiser un tournoi plus facilement ?"
        subtitle="Envoyez un message pour une démonstration, une question technique ou une mise en place personnalisée."
        variant="soft"
      >
        <FormContact />
      </PublicSection>
    </main>
  );
}

export default HomePageVitrine;